import ThreeSixtyIcon from '@mui/icons-material/ThreeSixty'
import { Box, Link, Typography } from '@mui/material'
import { useRecordContext, useTranslate } from 'react-admin'

/**
 * The boat's 360° tour, as the website and the portals show it: the provider's
 * own viewer (Kuula, Matterport …) in a frame.
 */
export const BoatPanorama = () => {
  const record = useRecordContext()
  const translate = useTranslate()
  const url: string | undefined = record?.panorama_url

  if (!url) {
    return (
      <Box
        sx={{ alignSelf: 'stretch', textAlign: 'center', py: 6, opacity: 0.6 }}
        data-testid='panorama-empty'
      >
        <ThreeSixtyIcon sx={{ fontSize: 96 }} />
        <Typography variant='body1'>{translate('resources.boats.panorama.empty')}</Typography>
      </Box>
    )
  }

  return (
    // The form tab lays its children out with align-items: flex-start, which
    // would shrink the frame to nothing; stretch to the tab's width instead.
    <Box sx={{ alignSelf: 'stretch', width: '100%', maxWidth: 1100 }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '16 / 9',
          borderRadius: 1,
          overflow: 'hidden',
          bgcolor: 'grey.900',
        }}
      >
        <iframe
          src={url}
          title={translate('resources.boats.panorama.title')}
          data-testid='panorama-frame'
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
          allow='fullscreen; xr-spatial-tracking; gyroscope; accelerometer'
          allowFullScreen
          loading='lazy'
          referrerPolicy='strict-origin-when-cross-origin'
        />
      </Box>
      <Link href={url} target='_blank' rel='noopener' sx={{ display: 'inline-block', mt: 1 }}>
        {translate('resources.boats.panorama.open')}
      </Link>
    </Box>
  )
}

export default BoatPanorama
